import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appCurrency]'
})
export class CurrencyDirective {

  private regex: RegExp = new RegExp(/^\$?\d{0,8}(\.\d{0,2})?$/g);
  private specialKeys: Array<string> = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Delete'];

  constructor(private el: ElementRef) {
    this.el.nativeElement.value = '$0.00';
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.specialKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.el.nativeElement.value.replace(/[^0-9.]/g, '');
    const next: string = current.concat(event.key);

    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }

    if (parseFloat(next) >= 100000000) {
      event.preventDefault();
    }
  }

  @HostListener('blur')
  onBlur() {
    let value: string = this.el.nativeElement.value.replace(/[^0-9.]/g, '');
    if (value) {
      value = parseFloat(value).toFixed(2);
      this.el.nativeElement.value = `$${value} `;
    } else {
      this.el.nativeElement.value = '$0.00';
    }
  }

  @HostListener('focus')
  onFocus() {
    let value: string = this.el.nativeElement.value.replace(/[^0-9.]/g, '');
    if (!value) {
      this.el.nativeElement.value = '';
    }
  }
}
